module.exports = __webpack_public_path__ + "img/Le Bon, La Brute et le Truand.52e5ff87.png";